<button
  type="button"
  class="row-icon-btn"
  [class.row-icon-btn--danger]="variant() === 'danger'"
  [disabled]="disabled() || busy()"
  [attr.aria-label]="ariaLabel() ?? tooltip()"
  [attr.aria-busy]="busy() ? 'true' : null"
  [pTooltip]="busy() ? (tooltip() + '…') : tooltip()"
  [tooltipPosition]="tooltipPosition()"
  (click)="onClick($event)"
>
  @if (busy()) {
    <i class="pi pi-spin pi-spinner" aria-hidden="true"></i>
  } @else {
    <i [class]="icon()" aria-hidden="true"></i>
  }
</button>
